import { ReactFlowProvider } from '@xyflow/react'
import { GeckoNotificationProvider } from 'features/notifications'
import React from 'react'
import { PfdNode } from 'types'

import { ProcessFlowDiagramBuilderDataLayer } from './contexts/ProcessFlowDiagramBuilderContext'
import { ProcessFlowDiagramBuilder } from './ProcessFlowDiagramBuilder'

interface ProcessFlowDiagramProps {
  siteID: string
  diagramID: string
  viewOnly?: boolean
  onNodeClick?: (node: PfdNode) => void
  selectedNodeByData?: { key: string; value: string }
  renderNodePopup?: (node: PfdNode, onClose: () => void) => React.ReactNode
  reactFlowClassName?: string
  hideHeader?: boolean
  hideMenuBar?: boolean
}

export const ProcessFlowDiagram: React.FC<ProcessFlowDiagramProps> = ({
  siteID,
  diagramID,
  viewOnly = false,
  onNodeClick,
  selectedNodeByData,
  renderNodePopup,
  reactFlowClassName,
  hideHeader = false,
  hideMenuBar = false,
}) => {
  return (
    <>
      <GeckoNotificationProvider>
        <ReactFlowProvider>
          <ProcessFlowDiagramBuilderDataLayer
            siteID={siteID}
            diagramID={diagramID}
            viewOnly={viewOnly}
            onNodeClick={onNodeClick}
            selectedNodeByData={selectedNodeByData}
            renderNodePopup={renderNodePopup}>
            <ProcessFlowDiagramBuilder
              viewOnly={viewOnly}
              reactFlowClassName={reactFlowClassName}
              hideHeader={hideHeader}
              hideMenuBar={hideMenuBar}
            />
          </ProcessFlowDiagramBuilderDataLayer>
        </ReactFlowProvider>
      </GeckoNotificationProvider>
    </>
  )
}
